if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');

      if (this.form) {
        this.form.querySelector('[name=id]') && (this.form.querySelector('[name=id]').disabled = false);
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.shouldRerenderCarousel = this.closest('[data-should-rerender-carousel]')?.getAttribute('data-should-rerender-carousel') === 'true';
      this.carouselSelector = this.closest('[data-should-rerender-carousel]')?.getAttribute('data-slider');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          if (this.shouldRerenderCarousel && this.carouselSelector) {
            window.slickReinit(this.carouselSelector);
          }
        })
        .then(() => {
          const attributes = window.cartAttributes || {};
          const isFragileGoodsProduct = formData.get("properties[Delivery type]") === 'Fragile goods';
          const current_id = formData.get('id');

          let fragile_goods_ids = attributes.fragile_goods_ids;
          if (isFragileGoodsProduct && fragile_goods_ids && !fragile_goods_ids.includes(current_id)) {
            fragile_goods_ids += "," + current_id;
          } else if (isFragileGoodsProduct && !fragile_goods_ids) {
            fragile_goods_ids = current_id;
          }

          const body = JSON.stringify({ attributes: { fragile_goods_ids } });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then(response => window.cartAttributes = response.attributes)
        })
        .catch((e) => {
          console.error(e);
        })
        .finally((e) => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
